import api from './axiosConfig';

/**
 * 전체 게시글 목록
 * - 서버가 배열을 주면 그대로 반환.
 * - { pinned,trending,normal } 구조면 그대로 반환.
 */
export async function fetchBoards(): Promise<any[] | { pinned: any[]; trending: any[]; normal: any[] }> {
    const res = await api.get('/board');
    const data = res.data;

    // 객체 형태일 때 유효성 체크
    if (data && typeof data === 'object' && !Array.isArray(data)) {
        const { pinned = [], trending = [], normal = [] } = data || {};
        if (Array.isArray(pinned) || Array.isArray(trending) || Array.isArray(normal)) {
            return { pinned, trending, normal };
        }
    }
    // 배열 fallback
    return Array.isArray(data) ? data : (data?.items ?? []);
}

/** 새 글 업로드 (FormData: title, content, image? or imageUrl?) */
export async function uploadBoardApi(formData: FormData): Promise<void> {
    const res = await api.post('/board', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    if (res.status < 200 || res.status >= 300) throw new Error('게시글 업로드 실패');
}

/** 상세 조회 */
export async function getBoardDetail(id: number): Promise<any> {
    const res = await api.get(`/board/${id}`);
    return res.data;
}

/** 조회수 트래킹 */
export async function trackViewApi(id: number): Promise<void> {
    await api.post(`/board/${id}/track-view`).catch((e) => {
        // 트래킹 실패는 치명적이지 않으므로 상위에서 처리할 수 있게 던지거나 무시
        throw e;
    });
}

/** 삭제 */
export async function deleteBoardApi(id: number): Promise<void> {
    const res = await api.delete(`/board/${id}`, {
        headers: {
            "X-User-Id": localStorage.getItem("userId"), // 또는 적절한 로그인 정보
        }
    });

    if (res.status < 200 || res.status >= 300)
        throw new Error('게시글 삭제 실패');
}

/** 신고 */
export async function reportBoardApi(payload: { id: number; reason: string }): Promise<void> {
    const res = await api.post(`/board/${payload.id}/report`, { reason: payload.reason });
    if (res.status < 200 || res.status >= 300) throw new Error('신고 실패');
}
